import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { CLOSE_STICKER } from "../../store/Sticker/Sticker.type";
import ReactDropzone from "react-dropzone";
import { editSticker, createSticker } from "../../store/Sticker/Sticker.action";
import { setToast } from "../../util/toast";
import noImage from "../../assets/img/No_image.png";

const StickerDialog = (props) => {
  const { dialog: open, dialogData } = useSelector((state) => state.sticker);

  const [type, setType] = useState("select Type");
  const [images, setImages] = useState([]);
  const [image, setImage] = useState(null);
  const [imagePath, setImagePath] = useState("");
  const [error, setError] = useState({});

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch({ type: CLOSE_STICKER });
  };

  // Set edit data
  useEffect(() => {
    if (dialogData) {
      setImagePath(dialogData?.sticker); // ✅ full URL already
      setType(dialogData?.type || "select Type");
    } else {
      setImagePath("");
      setType("select Type");
      setImages([]);
      setImage(null);
      setError({});
    }
  }, [dialogData]);

  const handelSubmit = () => {
    let validationError = {};

    if (!type || type === "select Type") {
      validationError.type = "Type is required!";
    }

    if (!dialogData && images.length === 0) {
      validationError.image = "Sticker image is required!";
    }

    if (dialogData && !image && !imagePath) {
      validationError.image = "Sticker image is required!";
    }

    if (Object.keys(validationError).length > 0) {
      return setError(validationError);
    }

    const formData = new FormData();
    formData.append("type", type);

    if (!dialogData) {
      images.forEach((img) => {
        formData.append("sticker", img);
      });
      props.createSticker(formData);
    } else {
      if (image) {
        formData.append("sticker", image);
      }
      props.editSticker(formData, dialogData._id);
    }

    handleClose();
  };

  // File change for edit
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);

    if (file) {
      setImagePath(URL.createObjectURL(file));
    }
  };

  // Dropzone upload
  const onPreviewDrop = (files) => {
    const acceptedImages = files.filter(
      (file) => file.type === "image/png" || file.type === "image/gif"
    );

    if (acceptedImages.length !== files.length) {
      setToast("error", "Only PNG and GIF stickers allowed");
    }

    acceptedImages.forEach((file) =>
      Object.assign(file, { preview: URL.createObjectURL(file) })
    );

    setImages(images.concat(acceptedImages));
  };

  const removeImage = (file) => {
    const filtered = images.filter((img) => img.preview !== file.preview);
    setImages(filtered);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle className="dialogue_background_color">
        <span className="modal-title font-weight-bold h4">Sticker</span>
      </DialogTitle>

      <IconButton style={{ position: "absolute", right: 0 }}>
        <Tooltip title="Close">
          <Cancel className="modal-title" onClick={handleClose} />
        </Tooltip>
      </IconButton>

      <DialogContent className="dialogue_background_color">
        <div className="modal-body pt-1 px-1 pb-3">
          <form>
            {/* TYPE */}
            <div className="form-group">
              <label className="mb-2 text-gray">Type</label>
              <select
                className="form-control"
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="select Type">Select Type</option>
                <option value="love">Love</option>
                <option value="emoji">Emojis</option>
              </select>

              {error.type && (
                <div className="text-danger mt-1">{error.type}</div>
              )}
            </div>

            {/* ADD MODE */}
            {!dialogData && (
              <div className="row mt-4">
                <div className="col-6">
                  <label>Select (Multiple) Image or Sticker</label>

                  <ReactDropzone onDrop={onPreviewDrop} accept=".png, .gif">
                    {({ getRootProps, getInputProps }) => (
                      <div {...getRootProps()}>
                        <input {...getInputProps()} />
                        <div
                          style={{
                            height: 130,
                            width: 130,
                            border: "2px dashed gray",
                            textAlign: "center",
                            marginTop: "10px",
                            cursor: "pointer",
                          }}
                        >
                          <i
                            className="fas fa-plus"
                            style={{ paddingTop: 30, fontSize: 70 }}
                          ></i>
                        </div>
                      </div>
                    )}
                  </ReactDropzone>

                  {error.image && (
                    <div className="text-danger mt-1">{error.image}</div>
                  )}
                </div>

                <div className="col-6 mt-4">
                  {images.map((file) => (
                    <div key={file.preview} style={{ position: "relative" }}>
                      <img
                        src={file.preview}
                        alt="preview"
                        width="60"
                        height="60"
                        style={{
                          borderRadius: 10,
                          marginRight: 10,
                          objectFit: "contain",
                        }}
                      />
                      <i
                        className="fas fa-times-circle text-danger"
                        style={{
                          position: "absolute",
                          right: 5,
                          top: 5,
                          cursor: "pointer",
                        }}
                        onClick={() => removeImage(file)}
                      ></i>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* EDIT MODE */}
            {dialogData && (
              <div className="mt-3">
                <label className="fw-bold">Image</label>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={handleImageChange}
                />

                {imagePath && (
                  <img
                    src={imagePath}
                    alt="sticker"
                    className="mt-3"
                    width="150"
                    height="100"
                    style={{ borderRadius: "12px", objectFit: "contain" }}
                    onError={(e) => (e.target.src = noImage)}
                  />
                )}

                {error.image && (
                  <div className="text-danger mt-1">{error.image}</div>
                )}
              </div>
            )}

            {/* BUTTONS */}
            <div className="mt-4 text-right">
              <button
                type="button"
                className="btn btn-info px-3"
                onClick={handelSubmit}
              >
                {dialogData ? "Update" : "Insert"}
              </button>

              <button
                type="button"
                className="btn btn-danger ml-2 px-3"
                onClick={handleClose}
              >
                Close
              </button>
            </div>
          </form>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default connect(null, { editSticker, createSticker })(StickerDialog);
